import { render, staticRenderFns } from "./SectionDefinition.vue?vue&type=template&id=ba9916f0&"
import script from "./SectionDefinition.vue?vue&type=script&lang=js&"
export * from "./SectionDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports